import React from 'react';
import { ToggleButtonGroup, ToggleButton, Tooltip } from '@mui/material';
import { GridView, ViewList, Timeline } from '@mui/icons-material';

/**
 * 파일 뷰 모드 타입
 * - grid: 그리드 뷰 (카드 형식)
 * - list: 리스트 뷰 (테이블 형식)
 * - timeline: 타임라인 뷰 (날짜별 그룹)
 */
export type ViewMode = 'grid' | 'list' | 'timeline';

interface FileViewModeToggleProps {
  value: ViewMode;
  onChange: (mode: ViewMode) => void;
}

/**
 * 파일 뷰 모드 토글 컴포넌트
 * - 3가지 뷰 모드 전환
 * - 아이콘 버튼으로 표시
 * - 현재 모드 하이라이트
 */
const FileViewModeToggle: React.FC<FileViewModeToggleProps> = ({
  value,
  onChange,
}) => {
  const handleChange = (
    _event: React.MouseEvent<HTMLElement>,
    newMode: ViewMode | null
  ) => {
    // null 방지 (선택 해제 방지)
    if (newMode !== null) {
      onChange(newMode);
    }
  };

  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      onChange={handleChange}
      aria-label="파일 뷰 모드"
      size="small"
      sx={{ height: 40 }}
    >
      <ToggleButton value="grid" aria-label="그리드 뷰">
        <Tooltip title="그리드 뷰" arrow>
          <GridView fontSize="small" />
        </Tooltip>
      </ToggleButton>
      
      <ToggleButton value="list" aria-label="리스트 뷰">
        <Tooltip title="리스트 뷰" arrow>
          <ViewList fontSize="small" />
        </Tooltip>
      </ToggleButton>
      
      <ToggleButton value="timeline" aria-label="타임라인 뷰">
        <Tooltip title="타임라인 뷰" arrow>
          <Timeline fontSize="small" />
        </Tooltip>
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export default FileViewModeToggle;
